import TpCreditMemoReasonEnum from '../../Enums/CreditMemoReasonEnum';

export default class TpCreditMemoApplyItem {
  constructor(isApply, isLateFeeReimbursement, dataForCreditApply, creditMemo, invoiceMaxTotal) {
    if (!creditMemo) {
      return;
    }

    this.CreditType = 'Credit Percent';
    this.CreditPercentFee = 0;
    this.CreditPercentReimbursement = 0;
    this.CreditAmountFee = 0;
    this.CreditAmountReimbursement = 0;
    this.ApplyTaxOnly = false;
    this.IsLateFeeReimbursement = null;

    if (creditMemo.reason === TpCreditMemoReasonEnum.LateFeeCredit) {
      this.CreditPercentFee = isApply ? 100 : 0;
    } else if (creditMemo.reason === TpCreditMemoReasonEnum.TaxCredit) {
      this.CreditPercentFee = isApply && !isLateFeeReimbursement ? 100 : 0;
      this.CreditPercentReimbursement = isLateFeeReimbursement ? 100 : 0;
      this.ApplyTaxOnly = true;
      this.IsLateFeeReimbursement = isApply ? (isLateFeeReimbursement ? true : false) : null;
    }

    //These properties are only used on frontend in the ApplyCreditWindowDescription.js file
    this.LineItemCreditAmount = creditMemo.creditAmountNoTax;
    this.CurrencyCode = creditMemo.currencyCode;
    this.BaseFee = dataForCreditApply.selectedItemsFeeBase;
    this.BaseReimbursement = dataForCreditApply.selectedItemsReimbursement;
    this.NotSelectedCreditAmount = dataForCreditApply.notSelectedCreditAmount;
    this.CreditAmountAfter = dataForCreditApply.notSelectedCreditAmount;
    this.MaxInvoiceAmount = invoiceMaxTotal;
  }
}
